export default __webpack_public_path__ + "static/media/css3.f1f1ae8b.svg";